import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import cn from 'classnames';
import Layout from '../../components/layout/Layout';
import DeviceSidebar from '../../components/common/features/DeviceSidebar';
import Device from '../../components/device/Device';
import Loader from '../../components/common/ui/Loader';
import useGetSubscriptions from '../../hooks/useGetSubscriptions';
import { getDeviceSn } from '../../utils/helpers';

import styles from './styles.module.scss';

const Devices = () => {
  const [searchParams] = useSearchParams();
  const [subscriptions, subscriptionsLoading, refetchSubs] =
    useGetSubscriptions();
  const initialId =
    parseInt(searchParams.get('subscription_id')) || subscriptions[0]?.id;
  const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);
  const selectedSubscription = subscriptions?.find(
    (subscription) => subscription?.id === selectedSubscriptionId,
  );
  const deviceSn = getDeviceSn(selectedSubscription?.properties);
  useEffect(() => {
    setSelectedSubscriptionId(initialId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialId]);

  if (subscriptionsLoading) {
    return (
      <Layout className={cn(styles.devicesPage, styles.devicesPageLoading)}>
        <Loader show={true} />
      </Layout>
    );
  }

  return (
    <Layout className={styles.devicesPage}>
      {deviceSn ? (
        <Device
          subscription={selectedSubscription}
          refetch={refetchSubs}
        ></Device>
      ) : (
        <>
          <p className={cn('text', styles.devicesPageNoInfo)}>
            Subscription has been cancelled or not activated. Please contact
            support{' '}
          </p>
        </>
      )}

      <DeviceSidebar
        notAllowSelectNotAvailableSubs={true}
        className={styles.devicesPageSidebar}
        subscriptions={subscriptions}
        selectedSubscription={selectedSubscriptionId}
        setSelectedSubscription={setSelectedSubscriptionId}
      />
    </Layout>
  );
};

export default Devices;
